import { processRawValue } from '@atlaskit/editor-common/process-raw-value';
import { Node as PMNode, type Schema, type Slice } from '@atlaskit/editor-prosemirror/model';
import type { Transaction } from '@atlaskit/editor-prosemirror/state';
import { Transform } from '@atlaskit/editor-prosemirror/transform';

import type { Suggestion } from '../../aiSuggestionsPluginType';

function createSliceFromToolCallValue(schema: Schema, value: string): Slice | null {
	try {
		const parsed = typeof value === 'string' ? JSON.parse(value) : value;
		const node = processRawValue(schema, parsed);
		if (!node || node.content.size === 0) {
			return null;
		}
		const slice = node.slice(0, node.content.size);
		return slice;
	} catch {
		return null;
	}
}

export const getInversion = (tr: Transaction, suggestion: Suggestion) => {
	const localIdToPos = new Map<string, { from: number; to: number }>();
	tr.doc.descendants((node, pos) => {
		const localId = node.attrs?.localId;
		if (localId) {
			localIdToPos.set(localId, { from: pos, to: pos + node.nodeSize });
		}
		return false;
	});
	/**
	 * For some reason, without transforming the doc back and forth,
	 * the steps are missing in subsequent transforms.
	 */
	const transform = new Transform(PMNode.fromJSON(tr.doc.type.schema, tr.doc.toJSON()));
	suggestion.toolCalls.forEach((toolCall) => {
		const localId = toolCall.arguments?.localId;
		const value = toolCall.arguments?.value;
		if (localId === undefined || value === undefined) {
			return;
		}
		const slice = createSliceFromToolCallValue(tr.doc.type.schema, value);
		if (!slice) {
			return;
		}
		const pos = localIdToPos.get(localId);
		if (!pos) {
			return;
		}

		switch (toolCall.name) {
			case 'insertNodeAfter':
				transform.insert(pos.to, slice.content);
				break;
			case 'replaceNode':
				transform.replaceRange(pos.from, pos.to, slice);
				break;
			default:
				break;
		}
	});
	return transform;
};
